import store from "CommonState/store";
import {
  Component,
} from "react";
import CookieBanner, {
  getCookie,
} from "Components/cookie-banner";

@store("user")
export default class DashboardFooter extends Component {
  render() {
    const heute = new Date();
    const { user } = this.props;
    const info = user && user.serverinfo;
    return getCookie("eportal")
? <div className='footer' style={this.props.pinBottom ? { position: "fixed", bottom: "0", left: "0", right: "0" } : null}>
  { info && <small>Rev. { info.revision } </small>}
  <div className='float-end'>Copyright (c) 2017- {heute.getFullYear()} Bergische Universität Wuppertal - <a href='https://www.uni-wuppertal.de/impressum'>Impressum</a>
    {`\u00a0`}- <a href='https://www.uni-wuppertal.de/de/datenschutz'>Datenschutz</a>
    {`\u00a0`}- <a href='http://www.prounix.de'>Realisierung</a></div>
</div>
: <CookieBanner onSave={ () => this.forceUpdate() } />;
  }
}
